import { FunctionComponent, useCallback, useEffect, useState } from "react";
import { RouteComponentProps, useParams, withRouter } from "react-router-dom";
import Select, { MultiValue } from "react-select";
import AsyncSelect from "react-select/async";
import { Guid } from "../../../api/baseApi";
import { CampaignPeriod, CampaignStatus, getCampaignsBase } from "../../../api/campaingsApi";
import { getBaseChannels, getChannels } from "../../../api/channelsApi";
import { getMosaicList, getMosaicSingle } from "../../../api/mosaicApi";
import { ChannelAndCampaignReportRow, getCampaignAndChannelReport, getCampaignAndChannelReportDownloadLink, getSkinReports, SkinReportRow } from "../../../api/reportsApi";
import { formatDuration, formatDurationLong } from "../../../services/common";
import { currentDateString, formatDate, getPastDateByDaysAgo } from "../../../services/dateService";
import { Button } from "../../components/Button";
import { FormRow } from "../../components/formRow/FormRow";
import GlobalSpinner from "../../components/globalsSpinner/GlobalSpinner";
import IconButton from "../../components/iconButton/IconButton";
import InnerLayout from "../innerLayout/InnerLayout";
import Pagination from "../../components/pagination/Pagination";
import { getPagesCount } from "../../../services/paginator";

export interface ReportPageProps  extends RouteComponentProps<any>
{
    logOut : () => void;
    toogleCollapse: () => void;
    isCollapsed: boolean;
}

type Option<T> = { value: T, label: string} 

const MosaicCampaignAndChannelReport: FunctionComponent<ReportPageProps> = (props) => {
    let {logOut, toogleCollapse, isCollapsed} = props;

    let [ rows, setRows ] = useState<SkinReportRow[]>([]);
    let [ rowsToDisplay, setRowsToDisplay ] = useState<SkinReportRow[]>([]);

    let [ skins, setSkins ] = useState<Option<Guid>[]>([]);
    let [ sites, setSites ] = useState<Option<Guid>[]>([]);

    let [selectedSkins, setSelectedSkins] = useState<Option<Guid>[]>([]);
    let [selectedSites, setSelectedSites] = useState<Guid[]>([]);

    let [selectedStartDate, setSelectedStartDate] = useState<string>(currentDateString());
    let [selectedEndDate, setSelectedEndDate] = useState<string>(currentDateString());

    let [isLoading, setIsLoading] = useState<boolean>(false);
    let [currentPage, setCurrentPage] = useState<number>(1);
    let [minDateReport, setMinDateReport] = useState(getPastDateByDaysAgo(90));

    let { skinId } = useParams<{skinId: Guid}>();

    let itemsPerPage = 25;

    useEffect(() => {
        async function fetchData() {
            let sitesPromise = getBaseChannels();
            let skinPromise = getMosaicList();
            
            await Promise.all([sitesPromise, skinPromise, updateReportList(skinId)]).then(([sitesResult, skinsResult, reportResult]) => {
                if(sitesResult.type === "succes") setSites(sitesResult.data.items.map(it => {return {value: it.id, label: it.name}}));
                if(skinsResult.type === "succes") {
                    setSkins(skinsResult.data.items.map(it => {return {value: it.id, label: it.name}}));
                    if(skinId){
                        setSelectedSkins(skinsResult.data.items.filter(it => it.id === skinId).map(it => {return {value: it.id, label: it.name}}));
                    }
                };
            }); 
        } 

        fetchData();
    }, [])

    useEffect(() => {
        let startIndex = (currentPage - 1)*itemsPerPage;
        let finishIndex = startIndex + itemsPerPage;
        setRowsToDisplay(rows.slice(startIndex, finishIndex));
    }, [rows, currentPage]);
    
    const updateReportList = async (skinId?: Guid) => {
        setIsLoading(true);
        let skinsList = skinId ? [skinId] : selectedSkins.map(it => it.value);
        var getReportResult = await getSkinReports(skinsList, selectedSites, selectedStartDate, selectedEndDate);
        if(getReportResult.type == "succes") {
            setRows(getReportResult.data.items); 
        }
        setIsLoading(false);
    }

    const onSkinsChange = (values: MultiValue<Option<Guid>>) => setSelectedSkins(values.map(it => it)); 
    const onSitesChange = (values: MultiValue<Option<Guid>>) => setSelectedSites(values.map(it => it.value)); 
    const onStartDateChanged = (event: React.ChangeEvent<HTMLInputElement>) => setSelectedStartDate(event.target.value);
    const onEndDateChanged = (event: React.ChangeEvent<HTMLInputElement>) => setSelectedEndDate(event.target.value); 

    const renderReportRow = (rows: SkinReportRow[]) => {
        return rows.map( (it, index) => {
            return <tr key={index}>
                <td>{it.channelName}</td>
                <td>{it.mosaicName}</td>
                <td>{it.itemName}</td>
                <td>{formatDuration(it.durationMs)}</td>
                <td>{it.playouts}</td>
            </tr>
        })
    }
 
    return (  
        <InnerLayout 
            activeTab="reports" 
            logOut={logOut} 
            toogleCollapse={toogleCollapse} 
            isCollapsed={isCollapsed}
        >
            <>
            <div className="filter-row">
                <div className="filter-group">               
                    <FormRow>
                        <label>Networks</label>
                        <Select 
                            options={sites} 
                            isMulti
                            classNamePrefix={`select`}
                            onChange={onSitesChange}
                        />    
                    </FormRow>
                    <FormRow>
                        <label>Skins</label>  
                            <Select 
                            options={skins} 
                            isMulti
                            value={selectedSkins}
                            classNamePrefix={`select`}
                            onChange={onSkinsChange}
                        />    
                    </FormRow>
                </div>
                <div className="generate-group">
                    <FormRow>
                        <label>Start</label>  
                        <input className="form-control" type="date" onChange={onStartDateChanged} value={selectedStartDate} min={minDateReport} ></input>  
                    </FormRow>
                    <FormRow>
                        <label>End</label>  
                        <input className="form-control" type="date" onChange={onEndDateChanged} value={selectedEndDate}></input>  
                    </FormRow> 
                    <div className="">
                        <label style={{"marginBottom": "4px", "display": "block"}} htmlFor="">&nbsp;</label>
                        <Button color="green" label="Update" onClick={updateReportList}/>
                    </div>                            
                    {/* <div className="export-pos">
                        <a href={downloadUrl} target="_blank"> <IconButton tooltipText="" type="export" /> </a>
                    </div> */}
                    
                </div>               
            </div>
            {
                rows.length === 0 ? <h2>No items</h2> : <>
                    <table className="table report-table">
                        <thead>
                            <tr>
                                <td>Network</td>
                                <td>Skin </td>
                                <td>Item</td>
                                <td>Duration</td>
                                <td>Playouts</td>
                            </tr>
                        </thead>
                        <tbody>
                            {renderReportRow(rowsToDisplay)}
                        </tbody>
                    </table>
                    <Pagination activePage={currentPage} pagesCount={getPagesCount(rows.length, itemsPerPage)} changePaginationPage={setCurrentPage} />
                </>
            }
            <GlobalSpinner isShow={isLoading} />
            </>
        </InnerLayout>
    );
}
 
export default withRouter(MosaicCampaignAndChannelReport);